import Cookies from "js-cookie";

let gaIsLaunched = false;

let defaultCookieConsent = {
	'ad_storage': false,
	'ad_user_data': false,
	'ad_personalization': false,
	'analytics_storage': false
}

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

gtag('consent', 'default', {
	'ad_storage': 'denied',
	'ad_user_data': 'denied',
	'ad_personalization': 'denied',
	'analytics_storage': 'denied'
});

if (params && params.ga_tag !== null && params.ga_on === "1") {
	var script = document.createElement('script');
	script.src = "https://www.googletagmanager.com/gtag/js?id=" + params.ga_tag;
	script.async = true;
	script.onload = function() {
		gtag('js', new Date());
		gtag('config', params.ga_tag, {
			'anonymize_ip': true
		});
	};

	document.head.appendChild(script);
}

var doNotTrack = navigator.doNotTrack || navigator.msDoNotTrack;

function maybeShowResult(elem) {
	if (document.querySelector("section.mLegales div.reponse")) {
		document.querySelector("section.mLegales div.reponse p").innerHTML = '<strong>' + elem.dataset.label + ': ' + elem.dataset.status + '</strong>';
	}
}


function updateCookieConsent(variable, value) {
	let cookieConsent = Cookies.get("DPC_Consent") ? JSON.parse(Cookies.get("DPC_Consent")) : {...defaultCookieConsent};

	cookieConsent[variable] = value;

	Cookies.set("DPC_Consent", JSON.stringify(cookieConsent), { expires: 365 });
	Cookies.set('DPC_CookiesBarConsent', true, { expires: 365 });

	sendUpdateToGtag();
}

function updateAllCookieConsent(value) {
	let cookieConsent = Cookies.get("DPC_Consent") ? JSON.parse(Cookies.get("DPC_Consent")) : {...defaultCookieConsent};

	cookieConsent['ad_storage'] = value;
	cookieConsent['ad_user_data'] = value;
	cookieConsent['ad_personalization'] = value;
	cookieConsent['analytics_storage'] = value;

	Cookies.set("DPC_Consent", JSON.stringify(cookieConsent), { expires: 365 });
	Cookies.set('DPC_CookiesBarConsent', true, { expires: 365 });

	sendUpdateToGtag();
}

function sendUpdateToGtag() {
	let cookieConsent = Cookies.get("DPC_Consent") ? JSON.parse(Cookies.get("DPC_Consent")) : {...defaultCookieConsent};

	gtag('consent', 'update', {
		'ad_storage': cookieConsent["ad_storage"] ? 'granted' : 'denied',
		'ad_user_data': cookieConsent["ad_user_data"] ? 'granted' : 'denied',
		'ad_personalization': cookieConsent["ad_personalization"] ? 'granted' : 'denied',
		'analytics_storage': cookieConsent["analytics_storage"] ? 'granted' : 'denied'
	});
}

export async function startCookies() {
	if (doNotTrack === 'yes' || doNotTrack === '1' || document.querySelector("#wpadminbar") !== null) {
		return false;
	}

	await sendUpdateToGtag();

	return true;
}

function changeCookieConsent(elem, value = false) {
	let valid = false;

	let idTrack;

	if (typeof elem === "string") {
		idTrack = elem;

		valid = true;
	} else {
		let idDom = elem.getAttribute("id");
		let idSplit = idDom.split("-");

		if (idSplit.length >= 2) {
			idTrack = idSplit[0];

			valid = true
			value = document.querySelector("input#" + idDom + ":checked").value;
			value = (value.toLowerCase() === 'true');
		}
	}

	if (valid) {
		switch (idTrack) {
			case "yes-to-all":
				updateAllCookieConsent(true);
				break;
			case "no-to-all":
				updateAllCookieConsent(false);
				break;
			case "ad_storage":
			case "ad_user_data":
			case "ad_personalization":
			case "analytics_storage":
				updateCookieConsent(idTrack, value);
				break;
			case "bandeauCookie":
				if (document.querySelector("div.bandeauCookie") !== null) {
					if (value === true) {
						changeCookieConsent("yes-to-all");
					} else if(value === false) {
						changeCookieConsent("no-to-all");
					}

					Cookies.set('DPC_CookiesBarConsent', true, { expires: 365 });

					document.querySelector("div.bandeauCookie").classList.remove("on");

					setTimeout(() => {
						document.querySelector("div.bandeauCookie").remove();
					}, 10000);
				}
		}

		maybeShowResult(elem);
	}
}

if (typeof window !== 'undefined') {
	window.DPC = window.DPC || {};
	window.DPC.cookies = {
		changeCookieConsent,
		updateCookieConsent,
		updateAllCookieConsent,
		sendUpdateToGtag,
		startCookies
	};
}

// Exports nommés pour une utilisation via modules
export { changeCookieConsent, updateCookieConsent, updateAllCookieConsent, sendUpdateToGtag };

export function main() {
	// Legal notices radios
	if (document.querySelector("section.mLegales") !== null) {
		if (document.querySelector("section.mLegales ul.mLegales button.moreInfos") !== null) {
			document.querySelectorAll("section.mLegales ul.mLegales button.moreInfos").forEach(function (elem) {
				elem.addEventListener("click", function (event) {
					event.preventDefault();
					document.querySelector("section.mLegales div.plusInfos#" + elem.getAttribute("id")).classList.toggle("on");
				});
			});
		}

		if (document.querySelector("section.mLegales div.contenu input.buttonRadioConsent") !== null) {
			document.querySelectorAll("section.mLegales div.contenu input.buttonRadioConsent").forEach(function (elem) {
				elem.addEventListener("change", function (event) {
					event.preventDefault();
					changeCookieConsent(elem);
				});
			});
		}
	}

	// CookieBar
	if (document.querySelector("div.bandeauCookie") !== null) {
		let cookieBarConsent = Cookies.get("DPC_CookiesBarConsent");

		if (cookieBarConsent !== null && cookieBarConsent !== true) {
			document.querySelector("div.bandeauCookie a.cookie-options").addEventListener("click", function (event) {
				changeCookieConsent("bandeauCookie", null);
			});
			document.querySelector("div.bandeauCookie button.cookie-accept").addEventListener("click", function (event) {
				event.preventDefault();
				changeCookieConsent("bandeauCookie", true);
			});
			if(document.querySelector("div.bandeauCookie button.cookie-decline")) {
				document.querySelector("div.bandeauCookie button.cookie-decline").addEventListener("click", function (event) {
					event.preventDefault();
					changeCookieConsent("bandeauCookie", false);
				});
			}
		} else {
			document.querySelector("div.bandeauCookie").remove();
		}
	}

	startCookies();
}
